import styled, { css } from 'styled-components';

import TableLayout, {
  TableNullState,
  TableTD,
  TableTH,
  TableTR,
} from 'dashboard/layouts/TableLayout';
import { VendorConfig } from 'dashboard/models/vendor-config';
import Spacer from 'design-system/components/Spacer';
import { Label, Paragraph } from 'design-system/components/Text';

const ExtractionNameTableTH = styled(TableTH)`
  width: 50%;
`;

const StyledTableTR = styled(TableTR)<{ active?: boolean }>`
  ${({ active }) =>
    active &&
    css`
      background-color: ${({ theme }) => theme.color.variants.primary.highlightLight};
    `}
  &:hover {
    cursor: pointer;
  }
`;

interface DataSourceConfigurationTableProps {
  configs: Record<string, VendorConfig[]>;
  selectedCountryCode?: string;
  handleConfigSelected: (countryCode: string) => void;
}

const DataSourceConfigurationTable = ({
  configs = {},
  selectedCountryCode,
  handleConfigSelected,
}: DataSourceConfigurationTableProps) => {
  const sortedConfigs = Object.keys(configs).sort();
  return (
    <>
      <Spacer height={0.5} />
      <TableLayout
        showHeader
        aria-role='treegrid'
        isEmpty={Object.keys(configs).length === 0}
        containerMaxHeight={512}
        nullState={
          <TableNullState>No configurations found on the verification template</TableNullState>
        }
        headerTR={
          <>
            <ExtractionNameTableTH isSticky>
              <Label size='md'>Country Code</Label>
            </ExtractionNameTableTH>
            <TableTH isSticky>
              <Label size='md'>Data Sources Configured</Label>
            </TableTH>
          </>
        }
      >
        {sortedConfigs.map((countryCode) => {
          const configurations = configs[countryCode];
          return (
            <StyledTableTR
              key={countryCode}
              id={countryCode}
              onClick={() => handleConfigSelected(countryCode)}
              active={countryCode === selectedCountryCode}
            >
              <TableTD>{countryCode}</TableTD>
              <TableTD>
                <Paragraph weight='light'>{configurations.length}</Paragraph>
              </TableTD>
            </StyledTableTR>
          );
        })}
      </TableLayout>
    </>
  );
};

export default DataSourceConfigurationTable;
